export default () => {

	const win = window;

	// Really basic check for the ios platform
	// https://stackoverflow.com/questions/9038625/detect-if-device-is-ios
	const iOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !win['MSStream'];

	// Get the device pixel ratio
	const ratio = win.devicePixelRatio || 1;

	// Define the users device screen dimensions
	const screen = {
		width : win.screen.width * ratio,
		height : win.screen.height * ratio
	};

	let iphoneX = false;
	let _notch  = '';

	// iPhone X Detection
	if (iOS && screen.width == 1125 && screen.height === 2436) {

		// Set a global variable now we've determined the iPhoneX is true
		iphoneX = true;

		// Adds a listener for ios devices that checks for orientation changes.
		win.addEventListener('orientationchange', () => {
			notch();
			iphoneXChecker();
		});
	}

	// Notch position checker
	function notch() {

		const screen = win['screen'];

		if( 'orientation' in win ) {
			// Mobile
			if (win.orientation == 90) {
				_notch = 'left';
			} else if (win.orientation == -90) {
				_notch = 'right';
			}
		} else if ( 'orientation' in screen ) {
			// Webkit
			if( screen['orientation'].type === 'landscape-primary') {
				_notch = 'left';
			} else if( screen['orientation'].type === 'landscape-secondary') {
				_notch = 'right';
			}
		} else if( 'mozOrientation' in screen ) {
			// Firefox
			if( screen['mozOrientation'] === 'landscape-primary') {
				_notch = 'left';
			} else if( screen['mozOrientation'] === 'landscape-secondary') {
				_notch = 'right';
			}
		}

	}

	const body = win.document.getElementsByTagName('body')[0];
	if (iphoneX === true) {
		body.classList.add('iphoneX');
	} else {
		body.classList.add('no-iphoneX');
	}

	function iphoneXChecker() {
		if (_notch == 'left') {
			body.classList.remove('notch-right');
			body.classList.add('notch-left');
		} else if (_notch == 'right') {
			body.classList.remove('notch-left');
			body.classList.add('notch-right');
		} else {
			body.classList.remove('notch-right', 'notch-left');
		}
	}

};


// WEBPACK FOOTER //
// ./src/app/iphoneX-checker.ts